import React from "react";
import PropTypes from "prop-types";
import { useAuthDataContext } from "components/auth";
import { FormattedMessage } from "react-intl";

const RestrictedEventVisible = ({
  event,
  children,
  fallback = (
    <h1>
      <FormattedMessage id="common.security.noAccess" />
    </h1>
  ),
}) => {
  const { hasAdminPrivileges } = useAuthDataContext();
  return hasAdminPrivileges || (event && event.visible) ? children : fallback;
};

RestrictedEventVisible.propTypes = {
  /**
   * Evento al que se intenta tener acceso
   */
  event: PropTypes.object,
  /**
   * Fallback si el usuario no tiene acceso, por defecto mensaje de no acceso
   */
  fallback: PropTypes.element,
};

export default RestrictedEventVisible;
